import React from "react";
import CaseStudyHeading from "../CaseStudiesHeading";
import CaseStudyProfile from "../CaseStudiesProfile";

// Sections
import Typography from "./TypographyOnTheWeb";
// import DesignProcess from "./DesignProcess";
import Outcomes from "./Outcomes";
import Adoption from "./Adoption";
import Feelix from "./Feelix";
import DesigningTheRoadmap from "./DesigningTheRoadmap";
import DesigningContributionModel from "./DesigningContribution";
import BuildOrBuy from "./BuildOrBuy";
import FeelixDesignTokens from "./FeelixDesignTokens";
import Guidelines from "./Guidelines";
import Muibook from "./Muibook";

const DesignSystems = () => {
  return (
    <React.Fragment>
      <CaseStudyHeading title="Design Systems" />
      <CaseStudyProfile>
        <p>
          I craft design systems that teams actually want to use, systems that are reusable, composable, and scalable.
          By working closely with designers and developers, I ensure both Figma and coded components align from the
          start, embedding tokenisation, accessibility, and flexibility into the foundation.
        </p>
        <p>
          A great design system isn’t just documentation; it’s a living, evolving product that enables teams to build
          faster while maintaining consistency and quality. My focus is on reducing friction, increasing adoption, and
          helping teams create with confidence.
        </p>
      </CaseStudyProfile>
      {Adoption}
      {Feelix}
      {Muibook}
      {Outcomes}
      {Guidelines}
      {DesigningTheRoadmap}
      {FeelixDesignTokens}
      {DesigningContributionModel}
      {BuildOrBuy}
      {Typography}
      {/* {DesignProcess} */}
    </React.Fragment>
  );
};

export default DesignSystems;
